import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import axios from 'axios'
import { MARKETING_URL, SMART_BANNER_EMBED_SNIPPET_URL } from '../utils/urls'

const downloadWordpressPlugin = (): Promise<string> =>
  axios
    .get(`${MARKETING_URL}/smart-banner/wordpress-plugin/download`, {
      responseType: 'blob',
    })
    .then((response) => {
      return window.URL.createObjectURL(new Blob([response.data]))
    })

interface SmartBannerEmbedSnippet {
  snippet: string
  slug: string
}

const fetchSmartBannerEmbedSnippet = (): Promise<SmartBannerEmbedSnippet> =>
  SBAPI.Fetch<SmartBannerEmbedSnippet>(SMART_BANNER_EMBED_SNIPPET_URL).then(
    (response) => response.data
  )

export { downloadWordpressPlugin, fetchSmartBannerEmbedSnippet }
